import { jsx } from "react/jsx-runtime";
import { forwardRef, Children, cloneElement } from "react";
import { useTheme, IconButton, darken, alpha } from "@mui/material";
import { useThemeColor } from "../../../themes/hooks/useThemeColor.es.js";
const EzIconButtonMui = forwardRef(
  ({ ariaHidden, ariaLabel, children, color, disabled, variant, ...props }, ref) => {
    const theme = useTheme();
    const isCommonColor = color == null ? void 0 : color.startsWith("common.");
    const themeColor = useThemeColor(disabled ? "common.disabled" : color);
    const outlineBoxShadow = `inset 0 0 0 2px ${themeColor}`;
    const Child = Children.only(children);
    const iconColor = variant === "filled" ? "common.white" : disabled ? "common.disabled" : color;
    return /* @__PURE__ */ jsx(
      IconButton,
      {
        ref,
        "aria-hidden": ariaHidden,
        "aria-label": ariaLabel,
        classes: {
          root: `EzIconButton EzIconButton-${variant}`,
          disabled: "EzIconButton-disabled"
        },
        color: isCommonColor ? void 0 : color,
        disabled,
        sx: {
          bgcolor: variant === "filled" ? themeColor : void 0,
          boxShadow: variant === "outlined" ? outlineBoxShadow : void 0,
          "&:focus": {
            outline: `2px solid ${theme.palette.common.black}`,
            outlineOffset: "2px"
          },
          "&:hover, &:active": {
            bgcolor: variant === "filled" ? darken(themeColor, 0.2) : alpha(themeColor, 0.1),
            borderColor: variant !== "basic" ? themeColor : void 0
          }
        },
        ...props,
        children: cloneElement(Child, {
          color: Child.props.color === "inherit" || Child.props.color == null ? iconColor : Child.props.color
        })
      }
    );
  }
);
EzIconButtonMui.displayName = "EzIconButtonMui";
export {
  EzIconButtonMui as default
};
//# sourceMappingURL=EzIconButtonMui.es.js.map
